import React from 'react'
import PropTypes from 'prop-types'
import Modalizer from 'components/modalizer/modalizer'
import AddToFolderWithNavigation from 'components/add_to_folder/add_lesson_to_folder_with_navigation'

const AddLessonToPrivateLibraryModal = props => (
	<Modalizer width='552px' height='565px' closeAction={props.closeSelected}>
		<AddToFolderWithNavigation
			title={props.title}
			handleCancelSelected={props.closeSelected}
			folders={props.folders}
			handleAddLesson={props.handleAddLesson}
			handleFolderIdUpdated={props.handleFolderIdUpdated}
			parentFolderId={props.parentFolderId}
			currentFolderName={props.currentFolderName}
		/>
	</Modalizer>
)

AddLessonToPrivateLibraryModal.propTypes = {
	closeSelected: PropTypes.func.isRequired,
	handleAddLesson: PropTypes.func.isRequired,
	handleFolderIdUpdated: PropTypes.func.isRequired,
	folders: PropTypes.array,
	title: PropTypes.string,
	parentFolderId: PropTypes.string,
	currentFolderName: PropTypes.string,
}

AddLessonToPrivateLibraryModal.defaultProps = {
	title: '',
	folders: [],
	currentFolderName: '',
}

export default AddLessonToPrivateLibraryModal
